import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { SampleTrackingLinksInfoStorage } from './sample-tracking-links-info-storage';
import { NavigationServiceLink } from './../service/navigation-service/navigation-service-link';

@Component({
    selector: 'sample-tracking-nav',
    template: require('./sample-tracking-navigation.component.html'),
    styles: [require('./sample-tracking-navigation.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingNavigationComponent {

    public topLevelMenu: Observable<NavigationServiceLink[]>;

    constructor(
        private sampleTrackingLinksInfo: SampleTrackingLinksInfoStorage) {

        this.topLevelMenu = this.sampleTrackingLinksInfo.all;
    }
}